import * as React from 'react';
import { observer } from "mobx-react";

import { DropdownView } from 'src/core/ui/dropdown.view';

interface AirlineEditorViewProps  {
    airlineRequest: DropdownRequest<AirlineSummary>;
    value: number | null;
	mode: ControlMode;
	onChanged: (airline?: AirlineSummary) => void;
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class AirlineEditorView extends React.Component<AirlineEditorViewProps, any> {
    public render() {
        let label = this.props.label;
        if (label === undefined) {
            label = 'Airline';
        }
        return (
            <DropdownView
                onGetErrorMessage={this.props.onGetErrorMessage}
                label={label}
                model={this.props.value}
                required={this.props.required}
                disabled={this.props.mode == 'display'}
				onChanged={this.props.onChanged}
                request={this.props.airlineRequest}
                keyField='id'
                textField='title'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/parts/airline-editor.view.tsx